import { useMutation, useQueryClient } from '@tanstack/react-query';
import { devStandardsApi } from '../api/devStandardsApi';
import type { UploadDevStandardsRequest } from '../types/devStandards';

/**
 * POST /api/eraf/standards — 개발표준 문서 업로드 (ROLE_ADMIN 전용)
 * 성공 시 active + list queryKey 무효화
 */
export function useUploadStandards() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: UploadDevStandardsRequest) => devStandardsApi.upload(body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['dev-standards', 'active'] });
      void queryClient.invalidateQueries({ queryKey: ['dev-standards', 'list'] });
    },
  });
}
